module.exports = __webpack_public_path__ + "static/footer_bg-316b7b365050bec8214721fecd123413.png";